import React from 'react'
import styled, { css } from 'styled-components'
import { addResponsivity, up, upBp } from '../lib/styles'

const Row = styled.div`
  ${({
    theme: { colors },
    responsive,
    alignItems,
    alignSelf,
    justifyContent,
    mobileAlignItems,
    maxWidth,
    position,
    margin,
    mobileMargin,
    padding,
    mobilePadding,
    wrap,
    width,
    shrink,
    grow,
    mobileWidth,
    height,
    bp = 'mobile',
    mobileFlexDirection,
    cursor,
  }) => css`
    display: flex;
    align-items: ${mobileAlignItems || alignItems};
    align-self: ${alignSelf};
    justify-content: ${justifyContent};
    max-width: ${maxWidth};
    width: ${mobileWidth || width};
    height: ${height};
    position: ${position};
    flex-shrink: ${shrink};
    flex-grow: ${grow};
    margin: ${mobileMargin || margin};
    padding: ${mobilePadding || padding};
    flex-direction: ${mobileFlexDirection || (responsive ? 'column' : 'row')};
    min-width: 0;
    cursor: ${cursor};

    ${upBp()} {
      width: ${width};
      flex-direction: row;
      margin: ${margin};
      padding: ${padding};
      align-items: ${alignItems};
    }
    /* 
    ${responsive &&
    css`
      flex-wrap: wrap;
    `} */

    flex-wrap: ${wrap};

    ${addResponsivity({ displayAs: 'flex' })}
  `}
`

export default Row
